<template>
<div class="animated fadeIn">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddUser">Add User</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card>
    <v-client-table :columns="columns" :data="users" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="roles" slot-scope="data">
        <ul>
          <li v-for="role in data.row.roles">
            {{ role.name }}
          </li>
        </ul>
      </template>
      <template slot="actions" slot-scope="data">
        <b-btn size="sm" variant="outline-success" @click="showUserRoles(data.row)" class="mr-1">Roles</b-btn>
        <b-btn size="sm" variant="outline-primary" @click="showEditUser(data.row)" class="mr-1">Edit</b-btn>
        <b-btn size="sm" variant="outline-danger" @click="showDeleteUser(data.row)">Delete</b-btn>
      </template>

    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddUser" title="Add User" hide-footer @hide="hideAddUser" no-enforce-focus>
      <user-form-add v-if="canShowAddUser" @success="addUserSuccess" @cancel="cancelAddRole" />
    </b-modal>
    <b-modal ref="modalEditUser" title="Edit User" hide-footer @hide="hideEditUser">
      <user-form-edit v-if="selectedUser" :user="selectedUser" @success="editUserSuccess" @cancel="cancelEditUser" />
    </b-modal>
    <b-modal ref="modalUserRoles" title="Set User Roles" hide-footer @hide="hideUserRoles" no-enforce-focus>
      <user-roles v-if="selectedUser" :user="selectedUser" @success="setUserRolesSuccess" @cancel="cancelUserRoles" />
    </b-modal>
    <b-modal ref="modalConfirm" title="Delete User" @ok="deleteUser">
      <div v-if="selectedUser" class="d-block text-center">
        <h4>Are you sure you want to delete this user?</h4>
      </div>
    </b-modal>
  </div>

</div>
</template>

<script>
import {
  mapState,
  mapActions
} from 'vuex'
import Vue from 'vue'
import UserFormAdd from './UserFormAdd'
import UserFormEdit from './UserFormEdit'
import UserRoles from './UserRoles'

export default {
  name: 'UserList',
  components: {
    UserFormAdd,
    UserFormEdit,
    UserRoles
  },
  data: function() {
    return {
      selectedUser: null,
      columns: ['id', 'name', 'email', 'roles', 'actions'],
      options: {
        headings: {
          id: 'ID'
        },
        sortable: [],
        filterable: ['id', 'name', 'email'],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddUser: false
    }
  },
  computed: mapState({
    users: state => state.users.all
  }),
  methods: {
    showAddUser() {
      this.canShowAddUser = true
      this.$refs.modalAddUser.show()
    },
    cancelAddRole() {
      this.$refs.modalAddUser.hide()
    },
    addUserSuccess() {
      this.$refs.modalAddUser.hide()
      this.$store.dispatch('users/getUsers')
    },
    hideAddUser() {
      this.canShowAddUser = false
    },
    showEditUser(user) {
      this.selectedUser = user
      this.$refs.modalEditUser.show()
    },
    cancelEditUser() {
      this.$refs.modalEditUser.hide()
    },
    editUserSuccess() {
      this.$refs.modalEditUser.hide()
      this.$store.dispatch('users/getUsers')
    },
    hideEditUser() {
      this.selectedUser = null
    },
    showUserRoles(user) {
      this.selectedUser = user
      this.$refs.modalUserRoles.show()
    },
    cancelUserRoles() {
      this.$refs.modalUserRoles.hide()
    },
    setUserRolesSuccess() {
      this.$refs.modalUserRoles.hide()
      this.$store.dispatch('users/getUsers')
    },
    hideUserRoles() {
      this.selectedUser = null
    },
    showDeleteUser(user) {
      this.selectedUser = user
      this.$refs.modalConfirm.show()
    },
    deleteUser() {
      this.$store.dispatch('users/deleteUser', {id: this.selectedUser.id})
      .then(() => {
        this.showSuccessMsg()
        this.$store.dispatch('users/getUsers')
      })
      .catch((error) => {
        if (error.response.status == 422) {
          this.showErrorMsg({
            message: this.getResponseErrorMessage(error.response.data)
          })
        } else {
          this.showErrorMsg()
        }
      })
    },
  },
  created() {
    this.$store.dispatch('users/getUsers')
    this.$store.dispatch('roles/getRoles')
  }
}
</script>
